// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * How use it:
 * 1. by dispatch:
 *      dispatch({ type: "xBrands/update", data: { key: "isStick", value: true } });
 *      data => it has "key" -> object key and value
 * 2. by handler:
 *      xBrandsUpdate({ key: "isStick", value: true });
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xBrandsStateType = Readonly<{
    industries?: string[];
}>;

export const initialBrandsState: xBrandsStateType = {
    industries: [],
};

const reducer = {
    "xBrands/CompleteLoadBrandsIndustries": (draft: Draft<xBrandsStateType>, action: { collection: string[] }) => {
        draft["industries"] = action.collection;
    },
};

const xBrands = createTypedReducerWithImmer(initialBrandsState, reducer);

(reducers as any).xBrands = xBrands;

export type xBrandsState = {
    xBrands: xBrandsStateType;
} & ApplicationState;

type xBrandsReducers = {
    [key: string]: typeof xBrands;
};

export type xBrandsActions = Parameters<xBrandsReducers[keyof xBrandsReducers]>[1] | AnyAction;
